import { authEmailFooter, authEmailFrame } from './authEmailMarkup.js';

export function verificationChannels(channel = 'email', smsEnabled = false) {
    if (!['email', 'sms', 'both'].includes(channel)) throw new Error('Choose Email, SMS, or Both.');
    if (channel !== 'email' && !smsEnabled) throw new Error('Available after SMS activation');
    return channel === 'both' ? ['email', 'sms'] : [channel];
}

export function maskedEmail(email) {
    const [local, domain] = String(email).split('@');
    return `${local.slice(0, 1)}***@${domain}`;
}

export const NO_TEXT_CODE = "We couldn't text you a code. Ask your admin to add or check your mobile number.";

// Switch off: email exactly as before. Switch on: text only, never an email fallback
// (an inbox alone must not be able to unlock a reset or invitation).
export function verificationDelivery(smsEnabled, mobile) {
    if (!smsEnabled) return { channels: ['email'] };
    if (!mobile || !/^\+[1-9]\d{7,14}$/.test(mobile)) return { channels: [] };
    return { channels: ['sms'] };
}

/**
 * @param {string | null} [logo=null] Untrusted branding URL (Company -> Organization), accepted only over HTTPS;
 *   without one the Company name is the centered wordmark.
 */
export function verificationEmail(company, code, logo = null, whiteLabelEmails = false, poweredBy = false) {
    if (!/^\d{6}$/.test(code)) throw new Error('A 6-digit code is required.');
    const name = String(company || 'IntelAgent').replace(/[\r\n]+/g, ' ').replace(/\s{2,}/g, ' ').trim() || 'IntelAgent';
    return {
        subject: `Your ${name} verification code`,
        text: `${name}\n\nYour verification code: ${code}\n\nExpires in 10 minutes. This code can only be used once.\n\nDidn't request this? Ignore this email.\n\n${authEmailFooter(name, whiteLabelEmails, poweredBy)}`,
        html: authEmailFrame(name, logo,
            `<p style="text-align:center">Your verification code</p><p style="font-size:36px;font-weight:bold;letter-spacing:8px;text-align:center">${code}</p><p>Expires in 10 minutes. This code can only be used once.</p><p>Didn't request this? Ignore this email.</p>`, whiteLabelEmails, poweredBy),
    };
}

export function generateVerificationCode() {
    const bytes = new Uint32Array(1);
    // Rejection sampling avoids modulo bias, including codes beginning with zero.
    do { crypto.getRandomValues(bytes); } while (bytes[0] >= 4294000000);
    return String(bytes[0] % 1000000).padStart(6, '0');
}

export async function verificationHash(secret, userId, purpose, value) {
    if (!secret) throw new Error('Verification hashing secret is not configured.');
    const encoder = new TextEncoder();
    const key = await crypto.subtle.importKey('raw', encoder.encode(secret),
        { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
    const hash = await crypto.subtle.sign('HMAC', key, encoder.encode(`${userId}:${purpose}:${value}`));
    return Array.from(new Uint8Array(hash), (byte) => byte.toString(16).padStart(2, '0')).join('');
}
